var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysHelp = function SvgSysHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 12a10.003 10.003 0 0 1 6.173-9.238A10 10 0 1 1 12 22 9.995 9.995 0 0 1 2 12Zm1 0a9 9 0 1 0 9-9 9.01 9.01 0 0 0-9 9Zm8.5 4.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm0-2.09v-.648a1.283 1.283 0 0 1 1.029-1.242 2.452 2.452 0 0 0 1.156-4.162 2.373 2.373 0 0 0-.959-.55 2.466 2.466 0 0 0-2.91 1.247 2.404 2.404 0 0 0-.254 1.086.5.5 0 1 1-1 0 3.402 3.402 0 0 1 1.366-2.744 3.454 3.454 0 0 1 4.436.234c.389.367.684.821.863 1.325a3.44 3.44 0 0 1-.216 2.834 3.447 3.447 0 0 1-2.273 1.707h-.01a.3.3 0 0 0-.234.275v.639a.5.5 0 0 1-1 0h.006Z"
  })));
};
export default SvgSysHelp;